import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class BlockCenteredImageData {
  title?: BlockComponentText;
  image?: BlockComponentImage;
  text?: BlockComponentText;
  button?: BlockComponentButton;
  backgroundImage?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCenteredImageData {
  export function make(
    title?: string,
    image?: string,
    text?: string,
    button?: BlockComponentButton,
    backgroundImage?: string,
  ): BlockCenteredImageData {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      image: BlockComponentImage.make(image),
      text: text ? BlockComponentText.make(text) : undefined,
      button: BlockComponentButton.make(button.link, button.settings),
      backgroundImage: BlockComponentImage.make(backgroundImage),
    };
  }

  export function getDefault(
    image = '',
    title = '見出し',
    text = 'ここをクリックして表示したいテキストを入力してください。テキストは「太字」「文字サイズ」など編集することができます。',
  ): BlockCenteredImageData {
    return make(
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      image,
      text,
      BlockComponentButton.getDefault(),
    );
  }
}

export default BlockCenteredImageData;
